<template>
    <vx-card id="loader">
        <div class="vx-row header-title ml-3">
            <h3>Регионы</h3>
            <!-- <vs-button class="mt-2" color="success" @click="createRegion()" type="filled">
                Добавить регионы
            </vs-button> -->
        </div> 
        
        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/3">
                <label class="vs-input--label">
                    Страны
                </label>
                <v-select
                    multiple
                    :options="dicts.countries"
                    label="name"
                    placeholder="Выберите страны"
                    class="w-full"
                    v-model="form.countryIds"
                    :reduce="a => a.id">
                </v-select>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="form.searchPattern"
                        @input="onSearch"
                        autocomplete="off"
                        label="Поиск по названию"
                        placeholder="Введите название..."
                        class="mt-1 w-full"/>
                </div>
            </div>

            <div class="vx-col w-1/3 mt-6">
                <vs-button color="success" @click="loadRegions()" type="filled">
                    Показать
                </vs-button>
            </div>
        </div> 

        <vs-table stripe :data="regions" max-items="10" class="mt-5">
            <template slot="header">
            </template>
            <template slot="thead">
                <vs-th class="vs-lg-3">
                    Страна
                </vs-th>
                <vs-th class="vs-lg-1">
                    Код
                </vs-th>
                <vs-th class="vs-lg-3">
                    Название (RU)
                </vs-th>
                <vs-th class="vs-lg-3">
                    Название (EN)
                </vs-th>
                <vs-th class="vs-lg-2">
                    Действия
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{tr.countryName}} ({{ tr.countryCode }})</vs-td>
                    <vs-td>{{tr.regionCode}}</vs-td>
                    <vs-td>{{tr.regionName}}</vs-td>
                    <vs-td>{{tr.regionTranslation}}</vs-td>
                    <vs-td>
                        <div class="inline-block">
                            <router-link :to="{ name: 'region-edit', params: { id: tr.id } }">
                                <vx-tooltip text="Редактировать" position="top" delay=".3s">
                                    <feather-icon icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7"/>
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Удалить" position="top" delay=".3s">
                                <feather-icon @click="showDeleteModal(tr)" icon="XCircleIcon" class="inline-block mr-2 text-danger" svgClasses="w-7 h-7"/>
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>

        <sweet-modal ref="deleteModal" icon="error" title="Удаление">
            <div class="mb-5">Вы действительно хотите удалить {{selected.name}}?</div>

            <vs-button class="" color="danger" @click="deleteRegion(selected)" type="filled">
                Удалить
            </vs-button>
        </sweet-modal>
    </vx-card>
</template>


<script>
    import qs from 'qs';
    import axios from 'axios';
    import vSelect from "vue-select";
    import { SweetModal, SweetModalTab } from 'sweet-modal-vue'

    export default {
        name: 'regions',
        data() {
            return {
                regions: [],
                selected: {},
                page: 1,
                pageSize: 100,
                pagesTotal: 1,

                form: {
                    searchPattern: undefined,
                    countryIds: undefined
                },

                dicts: {
                    countries: []
                }
            }
        },
        components: {
            SweetModal,
            SweetModalTab,
            vSelect
        },
        methods: {
            loadRegions() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                const params = {
                    searchPattern: this.form.searchPattern,
                    countryIds: this.form.countryIds,
                    page: this.page,
                    size: this.pageSize,
                };

                this.axios
                    .all([
                        this.axios.get('regions/translations', {
                            params: params,
                            paramsSerializer: (params) => {
                                return qs.stringify(params, { arrayFormat: 'repeat' });
                            }
                        }),
                        this.axios.get('regions/count', {
                            params: params,
                            paramsSerializer: (params) => {
                                return qs.stringify(params, { arrayFormat: 'repeat' });
                            }
                        }),
                        this.axios.get('regions/dicts', {
                            params: params
                        })
                    ])
                    .then(
                        axios.spread((regions, count, dicts) => {
                            this.regions = regions.data;
                            this.dicts.countries = dicts.data.countries;
                            this.pagesTotal = Math.ceil(count.data / this.pageSize);
                        })
                    )
                    .catch((err) => {
                        this.$vs.notify({
                            title: 'Ошибка!',
                            text: 'Ошибка загрузки данных.',
                            color: 'danger'
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                    });
            },
            showDeleteModal(region) {
                this.selected = region;
            },
            deleteRegion(region) {
                this.$axios({
                    method: 'DELETE',
                    url: 'regions/' + region.id,
                    errors: this.errors,
                    success: () => {
                        this.regions = this.regions.filter(c => c.id != region.id);
                        this.$refs.deleteModal.close();
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно удалено",
                            text: "Регион успешно удален.",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        this.$refs.deleteModal.close();
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при удалении!",
                            color: "danger",
                        });
                    }
                })
            },
            onSearch() {
                // this.loadRegions();
            }
        },
        watch: {
            page: function () {
                this.loadRegions();
            }
        },
        mounted() {
            this.loadRegions();
        }
    }
</script>

<style lang="scss">
    table {
        tr.selected {
            cursor: text !important;
        }
    }
    thead {
        th {
            font-size: 15px !important;

            .sort-th {
                i {
                    font-size: 19px;
                }
            }
        }
    }
    .header-title {
        flex-direction: column;
    }
    .vs-pagination--mb {
        justify-content: center !important;
    }
</style>